import {Typography} from "@mui/material";
import packageInfo from '../../package.json';

const VersionInfo = () => {
  return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Version: ' + packageInfo.version}
      </Typography>
  );
}

export default VersionInfo;